import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'; // Import Link for routing
import './Home.css'; // Custom CSS for this component
import Banner from '../img/BannerW.webp'

function Home() {
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const handleZoom = () => {
      const zoomLevel = window.outerWidth / window.innerWidth;
      setIsMobileView(zoomLevel > 1.5 || window.innerWidth <= 768); // Adjust threshold for zoom detection
    };

    window.addEventListener('resize', handleZoom);
    handleZoom(); // Check on initial load

    return () => {
      window.removeEventListener('resize', handleZoom);
    };
  }, []);

  return (
    <div className={`home ${isMobileView ? 'mobile-friendly' : ''}`}>
      {/* SEO Meta Tags */}
      <head>
        <title>Dog Waste Removal | Pet Waste Cleanup | Buffalo & Amherst</title>
        <meta name="description" content="Reliable dog waste removal services in Buffalo, Amherst, Tonawanda, and Williamsville. Keep your yard clean and pet-friendly!" />
        <meta name="keywords" content="dog waste removal, pet waste cleanup, yard cleaning, Buffalo, Amherst, Tonawanda, Williamsville" />
      </head>
      
      {/* Main Banner */}
      {/* Main Banner */}
      <div 
        className="main-banner bg-cover bg-center text-white" 
        style={{ backgroundImage: `url(${Banner})` }}
      >
        <div className="container text-center p-8 rounded-lg">
          <h1>Professional Dog Waste Removal in Buffalo & Surrounding Areas</h1>
          <p>Say goodbye to dog poop – Services begin April 1st!!</p>
          <a href="https://client.sweepandgo.com/doggy-duty-wny-g5m48/register" className="btn-primary" target="_blank" rel="noopener noreferrer">
            Get My Free Quote
          </a>
        </div>
      </div>

      {/* Areas We Service Section */}
      <section className="areas-we-service py-5">
        <div className="container">
        <p className="font-bold text-2xl mt-2">
          <strong>Sign up today</strong> and get <strong>FREE weekly cleanups</strong> for the entire month of March! 🧹✨
        </p>
        <p className="text-primary font-bold hover:underline">
          <a href="/contact">Learn More</a>
        </p>
          <div className="row">
            <div className="col-md-6">
              
              <h2>Service Areas</h2>
              <p>We proudly provide pet waste removal in the following locations:</p>
              <ul>
                <li>Buffalo</li>
                <li>Amherst</li>
                <li>Williamsville</li>
                <li>Tonawanda</li>
                <li>Clarence</li>
              </ul>
              <p>Not sure if we cover your area? <a href="https://client.sweepandgo.com/doggy-duty-wny-g5m48/register" target="_blank" rel="noopener noreferrer">Check</a> today!</p>
            </div>
            <div className="col-md-6">
              <div className="map-container">
                {/* Embed Google Map iframe */}
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d93503.87764690734!2d-78.7944!3d43.0228!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2us!4v1736010657787!5m2!1sen!2us"
                  width="100%"
                  height="350"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  title="Google Map of Service Areas"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section py-5 bg-light">
        <div className="container text-center">
          <h2 className="font-weight-bold mb-4">Our Pet Waste Removal Services</h2>
          <p>Reliable, hassle-free, and eco-friendly dog waste cleanup services in Buffalo, Amherst, and nearby areas.</p>
          <div className="row">
            <div className="col-md-3">
              <div className="service-card p-4 mb-3" style={{ minHeight: '250px' }}>
                <h5>📞 Easy Sign-Up & Hassle-Free Scheduling</h5>
                <p>Sign up in minutes with no contracts or hidden fees. Choose from— 2x weekly, weekly, bi-weekly, or Monthly clean ups.</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="service-card p-4 mb-3" style={{ minHeight: '250px' }}>
                <h5>🧹 Thorough Cleanup & Odor Control</h5>
                <p>We remove all waste and sanitize your yard with pet-safe deodorizer for a fresh and hygienic outdoor space.</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="service-card p-4 mb-3" style={{ minHeight: '250px' }}>
                <h5>📸 Proof of Service & Secure Process</h5>
                <p>Receive before-and-after pictures and secure, locked gates after every visit to ensure your pet's safety.</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="service-card p-4 mb-3" style={{ minHeight: '250px' }}>
                <h5>🧼 Sanitized Equipment for a Healthier Yard</h5>
                <p>We disinfect all tools after each visit, using eco-friendly, pet-safe cleaning solutions to protect your yard.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section py-5 bg-light">
        <div className="container text-center">
          <h2>Get a Cleaner Yard Today!</h2>
          <p>Join all the happy pet owners who trust us for dog waste removal in Buffalo/Amherst and nearby areas.</p>
          <Link to="/contact" className="btn-primary">Get Started Now</Link>
        </div>
      </section>
    </div>
  );
}

export default Home;
